<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      :width="width"
      :height="height"
      rx="6"
      transform="matrix(-1 0 0 1 24 0)"
      :fill="bgColor"
    />
    <path
      d="M16.5 17L11.5 12L16.5 7"
      :stroke="arrowColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11 17L6 12L11 7"
      :stroke="arrowColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  props: {
    arrowColor: {
      type: String,
      default: '#FFFFFF'
    },
    bgColor: {
      type: String,
      default: '#CB2957'
    },
    width: {
      type: String,
      default: '24'
    },
    height: {
      type: String,
      default: '24'
    }
  }
}
</script>
